/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
     File Description : Footer bar for news Add | Edit Page
 --------------------------------------------------------------------------------- 
    Creation Details 
    Date Created				: 21/Aug/2020 
    Author						: Aditya Tijare
================================================================ 
*/
import React from "react";
import { Link } from "react-router-dom";
import DataPublishingAction from "../../../dataPublishing/news/actionButton";
import PropTypes from "prop-types";
import { getProductVariant } from "utilities";
import { PRODUCT_VARIANT } from "constants";

const FooterBar = (props) => {
  const productVariant = getProductVariant();

  const { selectedIndex } = props;
  const saveAccess = selectedIndex === 0 ? props?.accessActionSave : props?.accessActionContentSave;
  return (
    <div className="form-submit-box">
      <div className="footer-layout">
        {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
          <button
            type="button"
            className="cy-prev-btn btn btn-outline-dark cy-btn "
            onClick={() => {
              (props.selectedIndex === undefined && props.setCurrentTab(2)) ||
                (props.selectedIndex < 6 && props.setCurrentTab(props.selectedIndex - 1));
            }}
          >
            Previous
          </button>
        ) : null}
        {props.newsId !== "" && props.selectedIndex > -1 && props.selectedIndex < 5 ? (
          <button
            type="button"
            className="cy-next-btn btn btn-outline-dark cy-btn"
            onClick={() => {
              props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex + 1);
            }}
          >
            Next
          </button>
        ) : null}
      </div>
      <div className="footer-layout">
        <Link to="/news">
          <button type="button" className="btn btn-outline-dark cy-btn">
            Cancel
          </button>
        </Link>
        {selectedIndex !== 2 ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              if (selectedIndex == 3) {
                props.handleSave(true, "geography");
              } else if (selectedIndex == 4) {
                props.handleSave(true, "product");
              } else {
                props.handleSave(true);
              }
            }}
          >
            Save
          </button>
        ) : null}
        {selectedIndex === 2 && productVariant === PRODUCT_VARIANT.INSIDER ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              props.handleSave(true, "trend");
            }}
          >
            Save
          </button>
        ) : null}
        {props?.accessActionBasicPublish ? <DataPublishingAction newsId={props.newsId} {...props} /> : null}
      </div>
    </div>
  );
};

FooterBar.propTypes = {
  selectedIndex: PropTypes.number,
  handleSave: PropTypes.func,
  accessActionSave: PropTypes.string,
  setCurrentTab: PropTypes.func,
  accessActionBasicPublish: PropTypes.bool,
  accessActionContentSave: PropTypes.bool,
  newsId: PropTypes.string,
};

export default FooterBar;
